<template>
    <tr>
        <td class="cell-detail">
            <span>{{row.title}}</span>
            <a :href="row.website" target="_blank" class="cell-detail-description">{{row.readableWebsite}}</a>
        </td>
        <td class="cell-detail">
            <span>{{row.typeLabel}}</span>
            <span class="cell-detail-description" v-if="row.youtubeId">mit YouTube-Video</span>
        </td>
        <td>
            <be-progress animated striped height="10px" color="info" v-if="!categories"/>
            <span class="font-italic" v-else-if="!categories.length">Keine</span>
            <template v-else>
                <span class="badge badge-primary mr-1" v-for="cat in categories" :key="cat.id">{{cat.title}}</span>
            </template>
        </td>
        <td>
            <span class="font-italic" v-if="!row.tags">Keine</span>
            <template v-else>
                <span class="badge badge-secondary mr-1" v-for="tag in row.tags" :key="tag">{{tag}}</span>
            </template>
        </td>
        <td class="cell-detail">
            <span>{{row.readableUpdatedAt}}</span>
        </td>
        <td class="text-right">
            <div class="btn-group">
                <router-link class="btn btn-secondary" title="Bearbeiten" :to="{ name: 'edit-solution', params: { id: row.id } }"><i class="icon mdi mdi-edit"></i></router-link>
                <button class="btn btn-warning" title="Löschen" @click="removeCategories" v-if="row.hasCategories"><i class="icon mdi mdi-delete"></i></button>
            </div>
        </td>
    </tr>
</template>

<script>
    import errorHandler from '../../../../mixins/errorHandler';
    import Solution from '../../../../models/Solution';

    export default {
        mixins: [errorHandler],

        props: {
            row: {
                type: Solution,
                required: true,
            },
        },

        asyncComputed: {
            categories: vm => vm.row.getFrameworkCategories(),
        },

        methods: {
            async removeCategories() {
                try {
                    this.$emit('update', this.row.id, { frameworkCategories: [] });
                } catch (err) {
                    this.catchError(
                        'Löschen fehlgeschlagen',
                        'Die Kategorien der Solution konnten nicht entfernt werden.',
                        err,
                    );
                }
            },
        },
    };
</script>
